import { Injectable } from "@angular/core";
import { DataResponseDto } from "@dto/data-response.dto";
import { NotificationListFiltersTeamsDto } from "@dto/notification-list/notification-list-filters-teams.dto";
import { NotificationListFiltersEmailSmsDto } from "@dto/notification-list/notification-list-filters-email-sms.dto";
import { NotificationDetailDto } from "@dto/notification-detail/notification-detail.dto";
import { NotificationListDto } from "@dto/notification-list/notification-list.dto";
import { environment } from "@environments/environment";
import { AuthHttpClientService } from "@service/auth-http-client.service";
import { map, Observable, of, tap } from "rxjs";

@Injectable({
  providedIn: 'any',
})
export class NotificationService {
  private readonly notificationUrl: string = `${environment.tmnBackApi}/notification`;

  /**
   * Cache pour les event types par productId
   * Évite les appels HTTP redondants
   */
  private readonly eventTypeCache: { [productId: string]: string[] } = {};

  constructor(private readonly http: AuthHttpClientService) {
  }

  getNotificationListTeams(currentPageNumber: number, filters: NotificationListFiltersTeamsDto, pageSize: number): Observable<NotificationListDto> {
    return this.http.post<NotificationListDto>(`${this.notificationUrl}/list?page=${currentPageNumber}&size=${pageSize}`, filters);
  }

  getNotificationListEmailSms(currentPageNumber: number, filters: NotificationListFiltersEmailSmsDto, pageSize: number): Observable<NotificationListDto> {
    return this.http.post<NotificationListDto>(`${this.notificationUrl}/list?page=${currentPageNumber}&size=${pageSize}`, filters);
  }

  getNotificationDetail(sourceId: string): Observable<NotificationDetailDto> {
    return this.http.post<NotificationDetailDto>(`${this.notificationUrl}/detail/${sourceId}`);
  }

  getEventType(productId: string): Observable<string[]> {
    if (!!this.eventTypeCache[productId]) {
      return of(this.eventTypeCache[productId]);
    } else {
      return this.http.get<DataResponseDto<string>>(
        `${this.notificationUrl}/${productId}/eventtypes`
      ).pipe(
        map(response => response.data),
        tap(eventType => this.eventTypeCache[productId] = eventType)
      );
    }
  }
}



